import { Modal } from "@mui/material";
import React, { type CSSProperties, type ReactNode } from "react";
import styled from "styled-components";

import { IconButton } from "./IconButton";

type CustomModalProps = Record<string, any> &
  WrapperProps & {
    children?: ReactNode;
    className?: string;
    closeIcon?: boolean;
    modalOpen: boolean;
    setModalOpen: (open: boolean) => void;
    style?: CSSProperties;
  };

type WrapperProps = {
  height?: number | string;
  left?: number | string;
  padding?: number | string;
  right?: number | string;
  style?: CSSProperties;
  theme?: any;
  top?: number | string;
  width?: number | string;
};

export const CustomModal = ({
  children,
  className,
  closeIcon = true,
  height = "400px",
  left = "50%",
  modalOpen,
  padding = "4.2rem 2.4rem 2.4rem 2.4rem",
  right,
  setModalOpen,
  style,
  top = "50%",
  width = "400px",
  ...props
}: CustomModalProps) => {
  return (
    <Modal
      aria-describedby="modal-modal-description"
      aria-labelledby="modal-modal-title"
      onClose={() => setModalOpen(false)}
      open={modalOpen}
      {...props}
    >
      <Wrapper
        className={className}
        height={height}
        left={left}
        padding={padding}
        right={right}
        style={style}
        top={top}
        width={width}
      >
        {children}
        {closeIcon && (
          <IconButton
            buttonProps={{
              className: "cursor-pointer absolute right-2 block top-2",
              onClick: () => setModalOpen(false),
              variant: "tertiary",
            }}
            iconProps={{ iconName: "Close" }}
          />
        )}
      </Wrapper>
    </Modal>
  );
};

const Wrapper = styled("div")<WrapperProps>(({ height, left, padding, right, style, top, width }) => ({
  backgroundColor: "var(--color-surface-bright)",
  borderRadius: "7px",
  boxShadow: "var(--box-shadow-elevation-400)",
  height: height,
  left,
  padding,
  position: "absolute",
  right,
  textAlign: "center",
  top,
  transform: "translate(-50%, -50%)",
  width: width,
  ...style,
}));
